import { useSelector } from 'react-redux'

import './compare-mode-layer-panel.styl';
import { useUploadedFloodsRecords } from '../../../utils/queries/upload.queries';

function CompareModeLayerPanelFloodSection() {
  const firstScenarioSelection = useSelector(state => state.layerSelector.currentSelectedDamageLayer)
  const secondScenarioSelection = useSelector(state => state.buildingDamages.secondScenario)
  const firstScenario = firstScenarioSelection.scenario.split('_')
  const secondScenario = secondScenarioSelection?.scenario.split('_')
  const { data: floodRecords } = useUploadedFloodsRecords()

  const [firstCustomFloodName, secondCustomFloodName] = [
    floodRecords.find(x => x.id === firstScenarioSelection.customFlood),
    floodRecords.find(x => x.id === secondScenarioSelection?.customFlood)]
  
  return (
    <div className="compare-mode-layer-panel">
      <div className="compare-mode-layer-panel__single-scenario-wrapper">
        <div className="compare-mode-layer-panel__first-scenario-color" />
        {firstCustomFloodName ? (
          <span>
            {firstCustomFloodName.name.length > 30 ? `${firstCustomFloodName.name.substring(0, 30)}...` : firstCustomFloodName.name}
          </span>
        ) : (
          <span className="compare-mode-layer-panel__span">
            {firstScenario[0]}
            -year flood,
            {' '}
            {firstScenario[1] ? (
              <span>
                {firstScenario[1] === 'Measures' ? 'anti-flood measures included' : 'climate change included'}
              </span>
            ) : (
              <span>no scenario</span>
            )}
          </span> 
        )}
        
      </div>
      {!!secondScenario && (
        <div className="compare-mode-layer-panel__single-scenario-wrapper">
          <div className="compare-mode-layer-panel__second-scenario-color" />
          {secondCustomFloodName ? (
            <span>
              {secondCustomFloodName.name.length > 30 ? `${secondCustomFloodName.name.substring(0, 30)}...` : secondCustomFloodName.name}
            </span>
          ) : (
            <span className="radio__span">
              {secondScenario[0]}
              -year flood,
              {' '}
              {secondScenario[1] ? (
                <span>
                  {secondScenario[1] === 'Measures' ? 'anti-flood measures' : 'climate change included'}
                </span>
              ) : (
                <span>no scenario</span>
              )}
            </span>
          )}
          
        </div>
      )}
    </div>
  )
}

export default CompareModeLayerPanelFloodSection